import { supabase } from '@/integrations/supabase/client';
import { CURRENT_PROFILE_KEY } from '@/hooks/useCurrentProfile';
import type { QueryClient } from '@tanstack/react-query';

/**
 * Check if student lost is pending — reads from cached profile data
 */
export function checkStudentLostFromCache(studentLostPending: boolean | undefined): boolean {
  return studentLostPending === true;
}

/**
 * Acknowledge student lost and invalidate profile cache
 */
export async function acknowledgeStudentLost(
  userId: string,
  queryClient?: QueryClient,
): Promise<boolean> {
  const { error } = await supabase
    .from('profiles')
    .update({ student_lost_pending: false })
    .eq('user_id', userId);

  if (!error) {
    queryClient?.invalidateQueries({ queryKey: [CURRENT_PROFILE_KEY] });
  }

  return !error;
}
